<template>
    <div class="fc-placeholder">
        <span class="fc-placeholder__text">{{ text }}</span>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.fc-placeholder {
    cursor: pointer;
    border: dashed 2px var(--app-selectedBorderColor);
    margin: 24px;
    height: 100px;
    opacity: 0.35;
    background-color: white;
    position: relative;
    width: 100%;

    &__text {
        z-index: 2;
        pointer-events: none;
        display: flex;
        text-transform: uppercase;
        align-items: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: transparent;
        font-family: $default-font-family;
    }
}
</style>
